/**
 * Punto de entrada de la aplicación, evitar al máximo las modificaciones innecesarias en este fichero
 */

import { addNewForm } from './functions/addNewForm'
import { dynamicHours } from './functions/dynamicHours'
import { fundoAmbientalModal } from './functions/fundoAmbientalModal'
import { setTagsInDataLayer } from './functions/setTagsInDataLayer'
import './old'

console.info('versión 2.0.8')

dynamicHours()
window.onload = () => {
  fundoAmbientalModal()
  addNewForm()
  setTagsInDataLayer()
}

